@for(chip of chips(); track chip.field){
<mat-chip class="overview-header__chip--column">
	@if(chip.chipIconName){
	<ogs-m3-icon prefix="fal" [icon]="chip.chipIconName" matChipAvatar />
	}
	@if(chip.headerIconName){
	<ogs-m3-icon [icon]="chip.headerIconName" />
	} @else if(chip.translationInfo){
	<span class="column-chip__text">{{chip.translationInfo.defaultText | translate: chip.translationInfo.token : chip.translationInfo.scope
		}}</span>
	}
	<ogs-m3-icon prefix="fal" icon="xmark" matChipRemove (click)="removeChip(chip)" />
</mat-chip>
}